import {Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/throw';
import {AuthService} from './auth.service';
import {environment} from '../../environments/environment';

@Injectable()
export class AuthRefreshService {
  private refreshInProgress = false;
  private refresh$: ReplaySubject<boolean>;

  constructor(private injector: Injector, private router: Router) {}

  // Lazy lookup breaks the HttpService -> AuthRefreshService -> AuthService -> HttpService cycle.
  private get auth(): AuthService {
    return this.injector.get(AuthService);
  }

  handle401<T>(retry: () => Observable<T>): Observable<T> {
    if (!this.auth.token()) {
      this.forceLogout();
      return Observable.throw('not-authenticated');
    }
    return this.refresh().mergeMap((ok: boolean) => {
      if (ok) {
        return retry();
      }
      this.forceLogout();
      return Observable.throw('refresh-failed');
    });
  }

  // Exactly one refresh runs at a time; concurrent callers share its result.
  private refresh(): Observable<boolean> {
    if (this.refreshInProgress) {
      return this.refresh$.asObservable();
    }
    this.refreshInProgress = true;
    this.refresh$ = new ReplaySubject<boolean>(1);
    const subject = this.refresh$;
    this.auth.refreshToken().subscribe(
      (ok: boolean) => {
        this.refreshInProgress = false;
        subject.next(ok);
        subject.complete();
      },
      () => {
        this.refreshInProgress = false;
        subject.next(false);
        subject.complete();
      }
    );
    return subject.asObservable();
  }

  private forceLogout(): void {
    this.auth.logout();
    this.router.navigateByUrl(environment.loginPage);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth-refresh.service.ts